const FORM_CONTROLS_MARGIN_VERTICAL = 4;
const FORM_CONTROLS_LABEL_VALUE_MARGIN_VERTICAL = 2;

const StyleForms = {
  fieldsVerticalMargin:FORM_CONTROLS_MARGIN_VERTICAL,
  labelValueVerticalMargin:FORM_CONTROLS_LABEL_VALUE_MARGIN_VERTICAL,
  bootstrapFieldsVerticalMargin : "mt-" + FORM_CONTROLS_MARGIN_VERTICAL,

  normalLabel: {
    fontWeight: "bold",
    fontSize: "1.4em",
  },

  smallLabel: {
    fontWeight: "bold",
    fontSize: "1.1em"
  },

  normalText: {
    fontSize: "1.4em",
  }

};

export { StyleForms, FORM_CONTROLS_MARGIN_VERTICAL };
